var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("header"),_vm._t("default",[_c('router-view')]),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }